'use client';

import EligibilityGatedLink from 'components/EligibilityGatedLink';
import ArrowCircleRightIcon from 'components/icons/ArrowCircleRightIcon';
import { captureConversationStarted } from 'lib/analytics';

const ReadyToStartCta: React.FC = () => {
  return (
    <section className="ready-to-start-section">
      <div className="ready-to-start-container">
        <h2>Ready to start?</h2>
        <EligibilityGatedLink
          href="/check-audio"
          className="cta-link"
          gtmEvent="GetStartedClick"
          onClick={() => captureConversationStarted('ready_to_start')}
        >
          <button className="cta-button">
            Help me pick a plan
            <ArrowCircleRightIcon color="purple" />
          </button>
        </EligibilityGatedLink>
      </div>
    </section>
  );
};

export default ReadyToStartCta;
